<template>

  <div id="home">
    

    <img alt="Basketball logo" class="mx-auto w-40" src="../assets/basketball.png">
    <h1 class="text-4xl">Nerdy NBA data visualisations</h1>
    

  </div>
</template>
<style>
#home {
    text-align:center;

}
#home h1{
  padding-top: 2em;
  line-height: 1.5em;
  text-align:center;
  

}
</style>
